// extracted by mini-css-extract-plugin
export default {"mobile":"FfLqs","root":"a8IIO","onImage":"eLbVS"};